/**
 * Method to correctly format the base_urls.main value
 * @param {String} platform: One of the allowed platform value (fr, gb, es, it, de)
 * @param {String} rawUrl: (expected something like ://manomano.fr )
 */
export const getCorrectMainUrl = ({ platform = '', rawUrl = '' }) => {
    if (!platform || !rawUrl)
        throw new Error(
            '[getCorrectMainUrl]: Missing platform or rawUrl parameter',
        );
    const sanitizedPlatform = platform === 'gb' ? 'co.uk' : `${platform}`;
    const splitedUrl = rawUrl.split('.');
    splitedUrl.pop();
    return `${splitedUrl.join('.')}.${sanitizedPlatform}`;
};
